import { render, staticRenderFns } from "./MyCertificates.vue?vue&type=template&id=5b960875&scoped=true"
import script from "./MyCertificates.vue?vue&type=script&lang=js"
export * from "./MyCertificates.vue?vue&type=script&lang=js"
import style0 from "./MyCertificates.vue?vue&type=style&index=0&id=5b960875&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b960875",
  null
  
)

export default component.exports